module.exports = __webpack_public_path__ + "static/media/VCAA.10c7284d.svg";